var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13113_68870)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5888 1.05036C8.75889 1.45145 8.62389 1.91802 8.26751 2.16086C6.83658 3.14313 5.89973 4.79933 5.89973 6.67655C5.89973 9.69156 8.31611 12.1336 11.2995 12.1336C13.9102 12.1336 16.089 10.2618 16.5912 7.77341C16.6776 7.34504 17.0529 7.03944 17.4848 7.0449C17.9168 7.05036 18.284 7.36413 18.3596 7.79524C18.4514 8.31911 18.5 8.85663 18.5 9.40506C18.5 14.4283 14.4718 18.4992 9.50135 18.4992C4.5282 18.4992 0.5 14.4283 0.5 9.40506C0.5 5.05036 3.52655 1.41325 7.56825 0.521024C7.98943 0.428255 8.416 0.649264 8.5888 1.05036ZM4.5606 4.11175C3.16747 5.4378 2.30081 7.32048 2.30081 9.40506C2.30081 13.4242 5.52445 16.682 9.50135 16.682C12.5846 16.682 15.2143 14.7229 16.2402 11.9699C14.9524 13.2004 13.2137 13.9535 11.2995 13.9535C7.32256 13.9535 4.09892 10.6956 4.09892 6.67655C4.09892 5.77341 4.26361 4.90847 4.5606 4.11175Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13113_68870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.82349df1c0688ce3853f8cc8e3dadb76.svg";
export { ForwardRef as ReactComponent };